'use client';
import type { FC } from 'react';
import { routes } from '~/utils/routes';
import {
  Actionsheet,
  actionsheetOptionStyle,
  actionsheetOptionLinkStyle,
} from '@app/_components/actionsheet';
import { css } from '@styled-system/css';
import { VStack, Box } from '@styled-system/jsx';
import moreIcon from './assets/more-icon.svg';
import { useLocalHooks } from './use-local-hooks';
export interface ReportActionsheetProps {
  seriesId: string;
}

export const ReportActionsheet: FC<ReportActionsheetProps> = ({ seriesId }) => {
  const { isOpen, open, close } = useLocalHooks();

  return (
    <>
      <div data-testid="report-button" onClick={open}>
        <img
          src={moreIcon}
          alt="報告する"
          className={css({ cursor: 'pointer' })}
          loading="lazy"
        />
      </div>
      <Actionsheet open={isOpen || false} onClose={close}>
        <VStack
          position="relative"
          zIndex="actionsheet"
          className={css({ minHeight: '100px', minWidth: '100%' })}
        >
          <Box width="100%">
            <ul
              className={css({
                marginTop: '10px',
                paddingLeft: '8px',
                paddingRight: '8px',
                fontSize: 'size_14',
                fontWeight: '700',
                width: '100%',
              })}
            >
              <li className={actionsheetOptionStyle}>
                <a
                  href={`${routes.series.copyrightReport.image.url(seriesId)}`}
                  className={actionsheetOptionLinkStyle}
                  rel="nofollow"
                >
                  <span>作品カバー画像の転載</span>
                </a>
              </li>
            </ul>
          </Box>
        </VStack>
      </Actionsheet>
    </>
  );
};
